<script setup lang="ts">
import AppHeader from "./components/AppHeader.vue"
import AppSidebar from "./components/AppSidebar.vue"
import { UiConfirmationModal, UiToast } from "@/components"
import { useConfirmation } from "@/composables/useConfirmation"

const { state: confirmState, handleConfirm, handleCancel } = useConfirmation()
</script>

<template>
  <div class="fixed inset-0 flex w-screen flex-col bg-slate-50 text-slate-900">
    <AppHeader />

    <div class="flex min-h-0 flex-1">
      <AppSidebar />

      <main class="min-w-0 flex-1 overflow-y-auto p-6">
        <slot />
      </main>
    </div>

    <UiToast />

    <UiConfirmationModal
      v-model="confirmState.isOpen"
      :title="confirmState.title"
      :message="confirmState.message"
      :type="confirmState.type"
      :confirm-text="confirmState.confirmText"
      :cancel-text="confirmState.cancelText"
      :show-icon="confirmState.showIcon"
      :focus-confirm="confirmState.focusConfirm"
      :z-index="confirmState.zIndex"
      @confirm="handleConfirm"
      @cancel="handleCancel"
    >
      <template v-if="confirmState.contentKey === 'products-import-template'" #content>
        <div class="space-y-4 text-sm text-slate-700">
          <div class="rounded-md border border-blue-200 bg-blue-50 p-3">
            <p class="font-semibold text-slate-900">Importacao de produtos em 3 passos</p>
            <ol class="mt-2 space-y-1 list-decimal list-inside">
              <li>Selecione a empresa na tela de produtos.</li>
              <li>Baixe e preencha o template.</li>
              <li>Envie o arquivo para importar.</li>
            </ol>
          </div>

          <div class="rounded-md border border-slate-200 bg-white p-3">
            <p class="font-semibold text-slate-900">Campos obrigatorios da planilha</p>
            <div class="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-2">
              <div class="rounded border border-slate-200 bg-slate-50 px-2 py-1">
                <p class="font-mono text-xs text-slate-900">codigo_sku</p>
                <p class="text-xs text-slate-600">Codigo unico do produto</p>
              </div>
              <div class="rounded border border-slate-200 bg-slate-50 px-2 py-1">
                <p class="font-mono text-xs text-slate-900">nome_produto</p>
                <p class="text-xs text-slate-600">Nome exibido no sistema</p>
              </div>
              <div class="rounded border border-slate-200 bg-slate-50 px-2 py-1">
                <p class="font-mono text-xs text-slate-900">tipo_produto</p>
                <p class="text-xs text-slate-600">materia-prima, intermediario ou produto-final</p>
              </div>
              <div class="rounded border border-slate-200 bg-slate-50 px-2 py-1">
                <p class="font-mono text-xs text-slate-900">unidade_medida</p>
                <p class="text-xs text-slate-600">Simbolo ja cadastrado (ex.: un, kg, m)</p>
              </div>
              <div class="rounded border border-slate-200 bg-slate-50 px-2 py-1">
                <p class="font-mono text-xs text-slate-900">preco_custo</p>
                <p class="text-xs text-slate-600">Numero positivo (10,50 ou 10.50)</p>
              </div>
              <div class="rounded border border-slate-200 bg-slate-50 px-2 py-1">
                <p class="font-mono text-xs text-slate-900">pode_comprar</p>
                <p class="text-xs text-slate-600">sim/nao, true/false ou 1/0</p>
              </div>
            </div>
          </div>

          <div class="rounded-md border border-amber-200 bg-amber-50 p-3 text-xs text-amber-900">
            Dica: nao renomeie as colunas do template e nao inclua colunas extras.
          </div>
        </div>
      </template>
    </UiConfirmationModal>
  </div>
</template>

